import type { CartProduct } from "./slices/cartSlice"

const CART_KEY = "biosany.cart"

/** Lee el carrito persistido. Devuelve [] en SSR o si no hay/está corrupto. */
export function loadCart(): CartProduct[] {
	if (typeof window === "undefined") return []
	try {
		const raw = window.localStorage.getItem(CART_KEY)
		if (!raw) return []
		const parsed: unknown = JSON.parse(raw)
		return Array.isArray(parsed) ? (parsed as CartProduct[]) : []
	} catch {
		return []
	}
}

/** Persiste el carrito (se llama en cada cambio del store). */
export function saveCart(products: CartProduct[]): void {
	if (typeof window === "undefined") return
	try {
		window.localStorage.setItem(CART_KEY, JSON.stringify(products))
	} catch {
		// localStorage no disponible (modo privado, cuota) — se ignora.
	}
}

/** Elimina el carrito persistido (tras una compra exitosa). */
export function clearCart(): void {
	if (typeof window === "undefined") return
	try {
		window.localStorage.removeItem(CART_KEY)
	} catch {
		// ignore
	}
}
